@if (showUI()) {
    <div
        class="grid min-h-screen"
        [class.xl:grid-cols-[260px_1fr]]="!isSideMenuCollapsed()"
        [class.xl:grid-cols-[64px_1fr]]="isSideMenuCollapsed()"
    >
        <aside
            class="pointer-events-none fixed top-0 left-0 z-10 h-full xl:pointer-events-auto xl:relative xl:top-auto xl:left-auto xl:border-r xl:border-gray-200 xl:shadow-none"
            [class.w-[261px]]="!isSideMenuCollapsed()"
            [class.w-[64px]]="isSideMenuCollapsed()"
        >
            <app-side-menu
                [menuItems]="menuItems()"
                [isAdmin]="isAdmin()"
                [userInfo]="userInfo()"
                [hideLogout]="isIframe()"
                (logout)="logout()"
                class="pointer-events-auto"
            />
        </aside>
        <main class="flex h-full flex-col">
            <div class="h-full w-full bg-white lg:pt-[60px] xl:pt-0">
                <ng-container>
                    <router-outlet />
                </ng-container>
            </div>
        </main>
    </div>

    @if (showHelp()) {
        <app-help />
    }

    <p-toast position="bottom-center" />
} @else if (loginDisplay()) {
    <app-welcome (login)="login()" />
} @else if (showError()) {
    <app-error [messageType]="errorType()" (logout)="logout()" />
}
